// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"finish-upload-button_btnWrapper__229lZ","btnWrapper__finishBtn":"finish-upload-button_btnWrapper__finishBtn__3hcoU"};